import { DigitaiAion, DigitaiIssue, DigitaiIssueStatus } from '@apps/digitai';

export const isOpenAion = (issues: DigitaiIssue[], aion: DigitaiAion): boolean =>
{
    return issues?.some(issue =>
        issue.potentialIssueId === aion.potentialIssueId &&
        issue.fleetAircraftEngineSerialNumber === aion.fleetAircraftEngine.serialNumber &&
        issue.status === DigitaiIssueStatus.OPEN_ISSUE,
    );
};
